import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL || '';

export const apiClient = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

let accessToken: string | null = null;
let gamixAppId: string | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function setGamixAppId(appId: string | null): void {
  gamixAppId = appId;
}

export function getGamixAppId(): string | null {
  return gamixAppId;
}

apiClient.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  if (gamixAppId) {
    config.headers.set('gamix-app-id', gamixAppId);
  }
  return config;
});

let refreshPromise: Promise<string> | null = null;

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status !== 401 ||
      original._retry ||
      original.url?.includes('/authentication/refresh') ||
      original.url?.includes('/admins/login') ||
      original.url?.includes('/admins/verify') ||
      original.url?.includes('/admins/forget-password')
    ) {
      return Promise.reject(error);
    }

    original._retry = true;

    if (!refreshPromise) {
      refreshPromise = apiClient
        .post<{ access_token: string }>('/v2/authentication/refresh')
        .then((res) => {
          const token = res.data.access_token;
          setAccessToken(token);
          return token;
        })
        .finally(() => {
          refreshPromise = null;
        });
    }

    const newToken = await refreshPromise;
    original.headers.Authorization = `Bearer ${newToken}`;
    return apiClient(original);
  },
);
